import { FC, memo } from 'react';
import ReactDOM from 'react-dom';
import { useRecoilValue } from 'recoil';
import { Props } from './type';
import { Root, Header, Body, Footer } from './styled';
import Icon from '@/units/Icon';
import { translationDataState } from '../../../../../../store';
import { GameBookLocationType } from '@/components/tour/game/gameBook/types';
import { parseTourLink } from '@/_helpers/base';

export const ChapterDetails: FC<Props & { children?: any }> = memo(
  ({ book, chapter, onClose, moveToSweep }) => {
    if (
      !chapter ||
      !(chapter.locationType === GameBookLocationType.sweep && chapter.moveToSweepUuid)
    )
      return null;

    const translation = useRecoilValue(translationDataState);

    const { backgroundColor, backgroundOpacity, textColor, buttonColor } = book;

    const showFooter = !!chapter.moveToSweepUuid;

    const handleMoveToSweep = () => {
      try {
        if (chapter) {
          if (chapter.locationType === GameBookLocationType.sweep && chapter.moveToSweepUuid) {
            moveToSweep(chapter.moveToSweepUuid);
          } else if (
            chapter.locationType === GameBookLocationType.tourLink &&
            chapter.locationTourLink
          ) {
            const parsedLink = parseTourLink(chapter.locationTourLink);
            if (parsedLink) {
              moveToSweep(parsedLink.s, { x: parsedLink.x, y: parsedLink.y });
            }
          }
          onClose();
        }
      } catch (err) {
        console.error('gameBook ChapterDetails handleMoveToSweep error');
      }
    };

    return ReactDOM.createPortal(
      <Root
        background={backgroundColor}
        opacity={backgroundOpacity}
        color={textColor}
        withFooter={showFooter}
      >
        <Header>
          <h2>{chapter.title}</h2>
          <Icon.Close onClick={onClose} />
        </Header>
        <Body>{chapter.url ? <img src={chapter.url} alt="" /> : <p>{chapter.description}</p>}</Body>
        <Footer show={showFooter} buttonColor={buttonColor} color={textColor}>
          <button onClick={handleMoveToSweep}>
            {translation?.experienceTeleport || 'Take me there'}{' '}
            <Icon.ArrowRight fontSize="inherit" />
          </button>
        </Footer>
      </Root>,
      document.getElementById('page-root'),
    );
  },
);
